import React from 'react';
import { PerformanceTier } from '~/types/performanceTier';

import IconType from '../IconType';
import SVGIcon from '../SVGIcon';

const CSS = require('./BadgeWithCheckmark.module.scss');

type BadgeWithCheckmarkProps = {
  variant?:
    | 'default'
    | 'success'
    | 'success-inverted'
    | 'jade'
    | keyof typeof PerformanceTier;
} & IconType;

function BadgeWithCheckmark({ variant, ...props }: BadgeWithCheckmarkProps) {
  return (
    <SVGIcon {...props} size={props.size ?? 24} viewBox="0 0 24 24">
      <path
        d="M21.9999,11.9994946 C21.9999,17.5223126 17.5232234,21.9989892 12.0004054,21.9989892 C6.47758737,21.9989892 1.9999,17.5223126 1.9999,11.9994946 C1.9999,6.47667661 6.47758737,2 12.0004054,2 C17.5232234,2 21.9999,6.47667661 21.9999,11.9994946"
        data-variant={variant}
        className={CSS.Badge}
      />
      <path
        d="M10.6083377,15.86925 C10.5893377,15.86925 10.5713377,15.86825 10.5523377,15.86725 C10.2683377,15.85125 10.0043377,15.71625 9.82733769,15.49425 L7.21833769,12.23325 C6.87433769,11.80225 6.94433769,11.17325 7.37533769,10.82725 C7.80733769,10.48125 8.43433769,10.55425 8.78133769,10.98325 L10.6913377,13.37225 L15.7713377,8.29325 C16.1623377,7.90225 16.7953377,7.90225 17.1853377,8.29325 C17.5763377,8.68325 17.5763377,9.31625 17.1853377,9.70725 L11.3153377,15.57625 C11.1273377,15.76525 10.8733377,15.86925 10.6083377,15.86925"
        data-variant={variant}
        className={CSS.Checkmark}
      />
    </SVGIcon>
  );
}

export default BadgeWithCheckmark;
